import React, {lazy, Suspense} from 'react';
import Header from './component/header/Header';
import './index.css'
import NotFound from './pages/notfound/NotFound';
import {Route, Routes} from 'react-router-dom'

const Home = lazy(()=> import("./pages/home/Home"))
const Blog = lazy(()=> import("./pages/blog/Blog"))

function App() {
  return (
    <>
      <Header />
      <Suspense fallback={<h1>Loading...</h1>}>
        <Routes>
      <Route path='/' element={<Home />}/>
      <Route path='/blog' element={<Blog />}/>
      <Route path='/*' element={<NotFound />}/>
      </Routes>
      </Suspense>
      
    </>
  );
}

export default App;